import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Settings } from 'lucide-react';
import Logo from './Logo';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
            <Logo size="default" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#stock" 
              className="text-sm font-medium text-zinc-300 hover:text-white transition-colors"
              data-testid="nav-stock"
            >
              Stock
            </a>
            <a 
              href="#contacto" 
              className="text-sm font-medium text-zinc-300 hover:text-white transition-colors"
              data-testid="nav-contact"
            >
              Contacto
            </a>
            <Link 
              to="/admin/login" 
              className="text-sm font-medium text-zinc-500 hover:text-zinc-300 transition-colors flex items-center gap-2"
              data-testid="nav-admin"
            >
              <Settings size={16} />
              Admin
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/5">
            <nav className="flex flex-col gap-4">
              <a 
                href="#stock" 
                className="text-sm font-medium text-zinc-300 hover:text-white transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Stock
              </a>
              <a 
                href="#contacto" 
                className="text-sm font-medium text-zinc-300 hover:text-white transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contacto
              </a>
              <Link 
                to="/admin/login" 
                className="text-sm font-medium text-zinc-500 hover:text-zinc-300 transition-colors py-2 flex items-center gap-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Settings size={16} />
                Admin
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
